"use client";

import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourEnvironment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="4263" id="secure-your-environment" className="dark bg-background text-foreground relative overflow-hidden py-32 md:py-48 lg:py-[200px] px-6">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.04]">
        <svg viewBox="0 0 800 400" className="w-[120%] max-w-none" fill="none" stroke="currentColor" strokeWidth="0.5">
          <path d="M100,200 C200,100 300,300 400,200 C500,100 600,300 700,200" />
          <path d="M150,200 C250,150 350,250 400,200 C450,150 550,250 650,200" />
          <circle cx="400" cy="200" r="60" />
          <circle cx="400" cy="200" r="90" />
          <path d="M400,110 L400,290 M310,200 L490,200" />
          <path d="M340,140 C370,170 430,170 460,140 M340,260 C370,230 430,230 460,260" />
          <path d="M250,180 Q400,80 550,180 Q400,280 250,180" />
        </svg>
      </div>

      <div ref={ref} className={`relative mx-auto max-w-[780px] text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="flex items-center justify-center gap-3" aria-hidden="true">
          <span className="block h-px w-[80px] bg-primary/60" />
        </div>
        <div className="mt-3 flex items-center justify-center" aria-hidden="true">
          <svg viewBox="0 0 24 24" className="h-3 w-3 text-primary" fill="currentColor">
            <path d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z" />
          </svg>
        </div>
        <div className="mt-3 flex items-center justify-center gap-3" aria-hidden="true">
          <span className="block h-px w-[80px] bg-primary/60" />
        </div>

        {}
        <p className="mt-12 font-mono text-[11px] tracking-[0.3em] uppercase text-primary">
          VI. &mdash; Professional Consultation
        </p>

        {}
        <h2 className="font-default mt-8 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light leading-[1.1] text-foreground">
          Secure your
          <br />
          <em className="italic font-light">environment today.</em>
        </h2>

        {}
        <p className="font-default mx-auto mt-10 max-w-[640px] text-lg md:text-[19px] leading-relaxed text-foreground/85">
          With 26 years of certified expertise, MYB Services provides 
          clinical-grade mold inspection and environmental testing. Protect your 
          property and health with our precise, evidence-based diagnostic services.
        </p>

        {}
        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10">
          <Link to="/ContactPage" className="group relative inline-block">
            <Button size="lg" className="font-mono text-xs tracking-[0.25em] uppercase bg-primary text-white hover:bg-primary/90 px-8 h-14 rounded-lg shadow-md">
              Schedule Inspection
            </Button>
            <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 block h-px w-12 bg-primary transition-all duration-300 group-hover:w-20" />
          </Link>

          <Link to="tel:+15615606653" className="font-default text-base md:text-lg text-foreground/85 hover:text-foreground transition-colors inline-flex items-center gap-2 border-b border-border hover:border-primary pb-1">
            <Phone className="h-3.5 w-3.5" aria-hidden="true" />
            <span className="italic">or call (561) 560-MOLD</span>
          </Link>
        </div>

        {}
        <p className="mt-16 font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground">
          Licensed & Certified &middot; Dade, Broward & West Palm
        </p>
      </div>
    </section>;
}